import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import CompanyManage from 'view/companyManage';

const CompanyManagePage = () => {
	return (
		<PageTemplate>
			<CompanyManage /> 
		</PageTemplate>
	);
};

export default CompanyManagePage;

 